define('modules/start/dashboard/qualify/view',['require','exports','module','views/BaseView','i18n','d3','venn','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");
    var i18n = require("i18n");
    require("d3");
    var venn = require("venn");

    var container = "#venn-chart";

    var getSets = function(e, s, c, es, sc, ec, esc) {
        var SMS = i18n.t("PUBLIC.PRODUCTS.DASHBOARD.TITLES.SMS");
        var EMAIL = i18n.t("PUBLIC.PRODUCTS.DASHBOARD.TITLES.EMAIL");
        var COOKIES = i18n.t("PUBLIC.PRODUCTS.DASHBOARD.TITLES.COOKIES");
        var EMAIL_SMS = i18n.t("PUBLIC.PRODUCTS.DASHBOARD.TITLES.EMAIL_SMS");



        var sets = [{
                sets: [EMAIL],
                size: e
            }, {
                sets: [COOKIES],
                size: c
            }, {
                sets: [SMS],
                size: s
            }, {
                sets: [EMAIL, SMS],
                size: es
            }, {
                sets: [SMS, COOKIES],
                size: sc
            }, {
                sets: [EMAIL, COOKIES],
                size: ec
            }, {
                sets: [EMAIL, SMS, COOKIES],
                size: esc
            }];

        if (e === es) {

             sets = [{
                sets: [EMAIL_SMS],
                size: e
            }, {
                sets: [COOKIES],
                size: c
            }, {
                sets: [EMAIL_SMS, COOKIES],
                size: ec
            }];
        }

        return sets;
    };

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        events: {
            "render:venn": "onRenderVenn"
        },
        initialize: function() {
            $(window).on('resize.resizeview', this.render.bind(this));
        },
        onRenderVenn: function(event, data) {
            this.renderVenn(data.e, data.s, data.c, data.es, data.sc, data.ec, data.esc);
        },
        initPopover: function() {
            $("#qualificationHelp").popover({
                container: 'body',
                title: '<strong>'+ i18n.t("PUBLIC.PRODUCTS.DASHBOARD.TITLES.QUALIFICATION_HELP")+
                        '</strong><a href="javascript:$(\'#qualificationHelp\').popover(\'hide\');"'+
                        ' style="float: right; text-decoration: none;color: #000000;">x</a>',
                html: true,
                trigger : 'click',
                placement: 'left',
                content: i18n.t("PUBLIC.PRODUCTS.DASHBOARD.HELP.QUALIFICATION"),
                template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
            });
        },
        renderVenn: function(e, s, c, es, sc, ec, esc) {
            var widthContainer = $(container).width();

            var sets = getSets(e, s, c, es, sc, ec, esc);
            var chart = venn.VennDiagram()
                .width(widthContainer)
                .height(161);
            var div = d3.select(container);
            d3.select(container).datum(sets).call(chart);

            var tooltip = d3.select("body").append("div")
                .attr("class", "venntooltip");

            var colours = ["#9EA4CC", "#ECA441", "#97B052"];

            d3.selectAll(container + " .venn-circle path")
                .style("stroke-width", 1)
                .style("stroke-opacity", 0.6)
                .style("fill-opacity", 0.3)
                .style("fill", function(d, i) {
                    return colours[i];
                })
                .style("stroke", function(d, i) {
                    return colours[i];
                });

            d3.selectAll(container + " .venn-circle text")
                .style("font-weight", "bold")
                .style("font-size", "13px")
                .style("fill-opacity", 1)
                .style("fill", function(d, i) {
                    return colours[i];
                });

            div.selectAll("g")
                .on("mouseover", function(d, i) {
                    // sort all the areas relative to the current item
                    venn.sortAreas(div, d);
                    // Display a tooltip with the current size
                    tooltip.transition().duration(400).style("opacity", 0.9);
                    tooltip.text(d.size + " " + i18n.t("PUBLIC.PRODUCTS.DASHBOARD.TITLES.USERS"));
                    // highlight the current path
                    var selection = d3.select(this).transition("tooltip").duration(400);
                    selection.select("path")
                        .style("fill-opacity", d.sets.length == 1 ? 0.2 : 0.1)
                        .style("stroke-opacity", 1);
                })
                .on("mousemove", function() {
                    tooltip.style("left", (d3.event.pageX) + "px")
                        .style("top", (d3.event.pageY - 28) + "px");
                })
                .on("mouseout", function(d, i) {
                    tooltip.transition().duration(400).style("opacity", 0);
                    var selection = d3.select(this).transition("tooltip").duration(400);
                    selection.select("path")
                        .style("stroke-width", 1)
                        .style("stroke-opacity", 0.6)
                        .style("fill-opacity", d.sets.length == 1 ? 0.3 : 0.0);
                });
        },
        afterRender: function() {
            $('.popover').remove();
            this.initPopover();
            if ($(container).length &&
                (this.productsReport.get("email_users") > 0 ||
                this.productsReport.get("sms_users") > 0 ||
                this.productsReport.get("cookies_users") > 0)) {
                this.renderVenn(
                    this.productsReport.get("email_users"),
                    this.productsReport.get("sms_users"),
                    this.productsReport.get("cookies_users"),
                    this.productsReport.get("email_sms_users"),
                    this.productsReport.get("sms_cookies_users"),
                    this.productsReport.get("email_cookies_users"),
                    this.productsReport.get("email_sms_cookies_users")
                );
            }
        }
    });

    module.exports = Layout;

});

